import { render } from "./InvitationView.vue?vue&type=template&id=45306e11&scoped=true"
import script from "./InvitationView.vue?vue&type=script&lang=js"
export * from "./InvitationView.vue?vue&type=script&lang=js"

import "./InvitationView.vue?vue&type=style&index=0&id=45306e11&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45306e11"]])

export default __exports__